import { useMemo, useState } from "react";

import { Grid, useTheme } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { TransferInsert } from "store/api/transfer";
import http from "config/http";
import useAlertModal from "hooks/useAlertModal";
import { useFormContext } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";
import SuccessModal from "components/SuccessModal";

function TransferSubmit({ onClose }) {
  const notify = useNotify();
  const alert = useAlertModal();
  const theme = useTheme()

  const { handleSubmit, watch, reset } = useFormContext();

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [loading, setLoading] = useState(false)

  const amount = watch("amount");

  const isButtonDisabled = useMemo(() => !amount, [amount]);

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      await http.post(TransferInsert, {
        ...data,
        amount: parseFloat(data?.amount),
      });

      setOpenConfirmationModal(true)
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false)
  };

  return (
    <Grid item xs={12} mt={2}>
      <LoadingButton
        disabled={isButtonDisabled}
        fullWidth
        variant="contained"
        loading={loading}
        color={actionButtonBg(theme)}
        onClick={handleSubmit(onSubmit)}
      >
        انتقال
      </LoadingButton>

      {openConfirmationModal &&
        <SuccessModal
          title={"Transfer Successful"}
          subtitle={"Funds have been transfer successfully between your wallets."}
          open={openConfirmationModal}
          onClose={() => {
            reset();
            setOpenConfirmationModal(false)
            onClose()
          }}
        />
      }
    </Grid>
  );
}

export default TransferSubmit;
